// frontend/src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// Auth Pages
import Login from './pages/auth/Login';
import Register from './pages/auth/Register';

// Admin Layout & Pages
import AdminLayout from './components/layout/AdminLayout';
import Dashboard from './pages/admin/Dashboard';
import POS from './pages/admin/POS';
import Products from './pages/admin/Products';
import Categories from './pages/admin/Categories';
import Inventory from './pages/admin/Inventory';
import Reports from './pages/admin/Reports';
import Users from './pages/admin/Users';
import Customers from './pages/admin/Customers';
import BankAccounts from './pages/admin/BankAccounts';
import Settings from './pages/admin/Settings';
import AdminOrders from './pages/admin/Orders';
import AdminOrderDetail from './pages/admin/OrderDetail';
import AdminProfile from './pages/admin/Profile'; // ✅ ШИНЭ

// Customer Layout & Pages
import CustomerLayout from './components/layout/CustomerLayout';
import CustomerProducts from './pages/customer/Products';
import CustomerProductDetail from './pages/customer/ProductDetail';
import CustomerCart from './pages/customer/Cart';
import CustomerOrders from './pages/customer/Orders';
import CustomerOrderDetail from './pages/customer/OrderDetail';
import Checkout from './pages/customer/Checkout';
import CustomerProfile from './pages/customer/Profile';

// Print Receipt (NO LAYOUT)
import PrintReceipt from './pages/print/PrintReceipt';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<Navigate to="/login" replace />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />

          {/* Print Receipt Route - LAYOUT-аас ГАДУУР */}
          <Route path="/print-receipt/:id" element={<PrintReceipt />} />

          {/* Admin Routes - AdminLayout доторх nested routes */}
          <Route path="/admin" element={<AdminLayout />}>
            <Route index element={<Navigate to="/admin/dashboard" replace />} />
            
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="pos" element={<POS />} />
            <Route path="products" element={<Products />} />
            <Route path="categories" element={<Categories />} />
            <Route path="inventory" element={<Inventory />} />
            <Route path="reports" element={<Reports />} />
            <Route path="users" element={<Users />} />
            <Route path="customers" element={<Customers />} />
            <Route path="bank-accounts" element={<BankAccounts />} />
            <Route path="settings" element={<Settings />} />
            
            <Route path="orders" element={<AdminOrders />} />
            <Route path="orders/:id" element={<AdminOrderDetail />} />
            
            {/* ✅ ШИНЭ - Profile route */}
            <Route path="profile" element={<AdminProfile />} />
          </Route>

          {/* Customer Routes - CustomerLayout доторх nested routes */}
          <Route path="/customer" element={<CustomerLayout />}>
            <Route index element={<Navigate to="/customer/products" replace />} />
            
            <Route path="products" element={<CustomerProducts />} />
            <Route path="products/:id" element={<CustomerProductDetail />} />
            <Route path="cart" element={<CustomerCart />} />
            <Route path="checkout" element={<Checkout />} />
            <Route path="orders" element={<CustomerOrders />} />
            <Route path="orders/:id" element={<CustomerOrderDetail />} />
            <Route path="profile" element={<CustomerProfile />} />
          </Route>

          {/* 404 - Redirect to login */}
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>

        {/* Toast Notifications */}
        <ToastContainer
          position="top-right"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
        />
      </div>
    </Router>
  );
}

export default App;